import axios from 'axios'

export default {
    getRatingsForOffer({ offerId, take, skip }) {
        return axios.post('/public-rating/offer', { offerId, take, skip })
    },

    getRatingsForUser({ userId, take, skip }) {
        return axios.post('/public-rating/user-rating', { userId, take, skip })
    },

    getOfferByToken(token) {
        return axios.get(`/rating/calendar-event`, {
            params: {
                token: token,
            },
        })
    },

    rateOffer(request) {
        return axios.post('/rating/rate', request)
    },

    getRatingsForCompany({ companyId, take, skip }) {
        return axios.post('/public-rating/company-rating', { companyId, take, skip })
    },
}
